export const ALERTS = [
  {
    id: "30days",
    label: "30 days alert",
    description: "Notify 1 month before expiration date",
    days: 30,
  },
  {
    id: "15days",
    label: "15 days alert",
    description: "Notify 2 weeks before expiration date",
    days: 15,
  },
  {
    id: "7days",
    label: "7 days alert",
    description: "Notify 1 week before expiration date",
    days: 7,
  },
]
